<template>
  <div @click="listen($event)" class="icon-box" :style="`width: ${size/100}rem; height: ${size/100}rem;`">
    <template v-if="!listening">
      <svg :width="`${size/100}rem`" :height="`${size/100}rem`" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>click to play</title>
          <g id="编辑器3.1优化" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="局部变速（新版）" transform="translate(-238.000000, -198.000000)" fill="#3583FB" fill-rule="nonzero">
                  <g id="音频播放icon-" transform="translate(238.000000, 198.000000)">
                      <path d="M8,-1.33226763e-14 C12.416,-1.33226763e-14 16,3.584 16,8 C16,12.416 12.416,16 8,16 C3.584,16 -1.33226763e-14,12.416 -1.33226763e-14,8 C-1.33226763e-14,3.584 3.584,-1.33226763e-14 8,-1.33226763e-14 Z M6.05242274,4.61367919 C5.98149752,4.70233571 5.94285714,4.81249096 5.94285714,4.92602671 L5.94285714,11.0739733 C5.94285714,11.3501157 6.16671477,11.5739733 6.44285714,11.5739733 C6.55639289,11.5739733 6.66654814,11.5353329 6.75520467,11.4644077 L10.5976713,8.3904344 C10.8133022,8.21792963 10.8482629,7.90328344 10.6757582,7.68765248 C10.6526923,7.65882012 10.6265036,7.63263148 10.5976713,7.6095656 L6.75520467,4.5355923 C6.5395737,4.36308753 6.22492751,4.39804822 6.05242274,4.61367919 Z" id="形状结合"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else>
      <div @click="pause($event)" class="listening-icon">
        <b :style="`height:${size/300}rem`"></b>
        <b :style="`height:${size/200}rem`"></b>
        <b :style="`height:${size/300}rem`"></b>
        <b :style="`height:${size/400}rem`"></b>
        <b :style="`height:${size/250}rem`"></b>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ListenIcon',
  props: {
    listening: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 16
    }
  },
  methods: {
    listen(e) {
      e.stopPropagation()
      this.$emit('listen')
    },
    pause(e) {
      e.stopPropagation()
      this.$emit('pause')
    }
  }
}
</script>

<style lang="less" scoped>
.icon-box {
  position: relative;
  cursor: pointer;
}
.listening-icon {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(5, 8%);
  justify-content: center;
  align-items: end;
  column-gap: 6%;
  padding: 4px 0;
  border-radius: 50%;
  background-color: #3583FB;
  box-sizing: border-box;
  b {
    display: block;
    background-color: #fff;
    margin-bottom: 3px;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    &:nth-child(1) {
      animation: flash1 800ms linear infinite;
    }
    &:nth-child(2) {
      animation: flash2 800ms linear infinite;
    }
    &:nth-child(3) {
      animation: flash3 800ms linear infinite;
    }
    &:nth-child(4) {
      animation: flash4 800ms linear infinite;
    }
    &:nth-child(5) {
      animation: flash5 800ms linear infinite;
    }
  }
}
@keyframes flash1 {
  0% {
    height: 10%;
  }
  50% {
    height: 80%;
  }
  100% {
    height: 20%;
  }
}
@keyframes flash2 {
  0% {
    height: 80%;
  }
  50% {
    height: 20%;
  }
  100% {
    height: 60%;
  }
}
@keyframes flash3 {
  0% {
    height: 80%;
  }
  50% {
    height: 60%;
  }
  100% {
    height: 50%;
  }
}
@keyframes flash4 {
  0% {
    height: 90%;
  }
  50% {
    height: 40%;
  }
  100% {
    height: 80%;
  }
}
@keyframes flash5 {
  0% {
    height: 40%;
  }
  25% {
    height: 80%;
  }
  75% {
    height: 40%;
  }
  100% {
    height: 20%;
  }
}
</style>
